import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';  // Import Swiper components
import 'swiper/swiper-bundle.css'; // Import Swiper styles
import { Autoplay, Thumbs, Mousewheel } from 'swiper/modules';  // Import necessary Swiper modules
import styled from 'styled-components';
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useParams } from 'react-router-dom';
import { FaPlay } from "react-icons/fa";
import { withRouter } from 'react-router-dom'; // Import withRouter to access location in class components
import data from '../../BCCasino/providerData';


import GamesData from '../../../../WC_Api/WB_Category_Wise_Data.json';
import GamesSwiper from '../../../../WC_Api/GamesSwiper';
import WB_api_page_tabs from '../../../../WC_Api/WB_api_page_tabs';

const GridContainerNew = styled.div`
  // display: grid;
  gap: 5px;
  // border:1px solid pink;
  // border-radius: 0 20px 20px 20px;
  width: 100%;
  height:100%;
  // top:10px;
  display: flex;
  overflow: hidden;
  padding: 0 0.5rem;
  padding-top:2.2rem;

  justify-content: center;
  align-items: center;
  //  grid-template-columns: repeat(7, minmax(200px, 1fr));
  // grid-gap: 10px;
  // padding-right: 17px;
  // overflow-x: auto; /* Enables horizontal scrolling */
  // white-space: nowrap; /* Prevents line breaks, so content stays in a single line */
  // Mobile view (1 columns)
  // grid-template-columns: repeat(7, 1fr); /* Creates 3 equal columns */
  // grid-template-rows: 1fr; /* Only one row */

   // Tablet view (2 columns)
  // @media (min-width: 340px) {
  //   grid-template-columns: repeat(2, 1fr);
  // }

  // Tablet view (3 columns)
  // @media (min-width: 768px) {
  //   grid-template-columns: repeat(3, 1fr);
  // }

  // Desktop view (4 columns)
  // @media (min-width: 1024px) {
  //   grid-template-columns: repeat(5, 1fr);
  // }

  // Large Desktop view (6 columns)
  // @media (min-width: 1440px) {
  //   grid-template-columns: repeat(6, 1fr);
  // }
`;

const GridItem = styled.div`
  background-color: transparent;
  width: 100%;
  border-radius: 10px;

  // overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;

    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }

`;


const GridItemprovider = styled.div`
  background-color:#000;
  width: 100%;
  // height:70px;
  border-radius: 10px;
  padding:9px 12px;

// border:1px solid green;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative; /* Needed for the play icon */
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;

  /* For image */
  .swiper-slide-img {
    transition: opacity 0.3s ease; /* Smooth transition for image opacity */

    }

  &:hover {
    // background-color: rgba(0, 0, 0, 0.4); /* Background color on hover */
  cursor:pointer;
    }

  &:hover .swiper-slide-img {
    opacity: 0.3; /* Reduce opacity of the image on hover */
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px; /* Adjust icon size */
    color: white;
    opacity: 0;

    padding:13px;
    justify-item:center;
    text-align:center;
    background-color:#0009;
    border-radius:100%;
    transition: opacity 0.3s ease;
  }

  &:hover .play-icon {
    opacity: 1; /* Show play icon on hover */
  }

`;
const GamesSlotWrapper = styled.div`
  // background-color: #1C1E22;
  // padding: 2px;
  // border:1px solid red;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  // position: relative;
  margin-top: 40px !important;
  //  margin-top: 100px !important;
  // @media (max-width: 768px) {
  //   margin-top: 100px !important;
  // }
`;

const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 100%;  // Adjusts image width to fill the container
  height: auto; // Maintains aspect ratio for responsiveness
// border:1px solid red;



  @media (min-width: 467px) {
    width: 100%;
    height: auto;

  }
`;

const AllButtonRigthTitleContainer = styled.div`

  position: absolute;
  display:flex;
  gap:10px;
  width:100%;
  align-items:center;
 justify-content:space-between;
  top: -34px; //vivek
  // right: 0;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  margin: 0;
`;

const AllButtonTopTitleContainer = styled.div`
  background-color: #1C1E22;
  border-radius: 15px;
  display:flex;
  justify-caontent:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px 20px;
  margin: 0;
  cursor:pointer;

  @media (max-width: 350px) {
    display:none;
  }
`;
const PaginationButton = styled.div`
  background-color: #1C1E22;
  border-radius: 50%;
  display:flex;
  justify-content:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px;

`;

class ExploreModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exampleState: 'Hello, React!',
      searchQuery: '',
      selectedFilter: 'all', // Default filter is 'all'
      games: data,
      gameData2: GamesData
    };
    this.swiperRef = React.createRef();
    this.swiperRef1 = React.createRef();
    this.swiperRef2 = React.createRef();
    this.swiperRef3 = React.createRef();
    this.swiperRef4 = React.createRef();
    this.swiperRef5 = React.createRef();
    this.swiperRef6 = React.createRef();
    this.swiperRef7 = React.createRef();
    this.swiperRef8 = React.createRef();

  }

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location ?? {};
    const categories = this.props.categories ?? [
      { key: 'all', label: 'Lobby', icon: 'lobby.svg', path: '/casino' },
      { key: 'Originals', label: 'Originals', icon: 'BCOriginal.svg', path: '/casino/Originals' },
      { key: 'hot-games', label: 'Hot Games', icon: 'hotGames.svg', path: '/casino/hot-games' },
      { key: 'slots', label: 'Slot Games', icon: 'slot.svg', path: '/casino/slots' },
      { key: 'live-casino', label: 'Live Casino', icon: 'liveCasino.svg', path: '/casino/live-casino' },
      { key: 'providers', label: 'Providers', icon: 'providers.svg', path: '/casino/providers' },
    ]; // Fallback to an empty array


    // Check if pathname has changed and matches a category key
    if (pathname !== prevProps.location?.pathname) {
      const matchedCategory = categories.find((category) => pathname.includes(category.key));
      if (matchedCategory) {
        this.handleFilterChange(matchedCategory.key);
      }
      if (pathname === '/casino' || !categories.some((cat) => pathname.includes(cat.key))) {
        this.handleFilterChange('all');
      }

    }

  }

  // Custom method for next slide
  nextSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  };

  nextSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slideNext();
    }
  };

  // Custom method for previous slide
  prevSlideHandler8 = () => {
    if (this.swiperRef8.current && this.swiperRef8.current.swiper) {
      this.swiperRef8.current.swiper.slidePrev();
    }
  };


  handleSearchChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      // If input is cleared, update searchQuery immediately
      if (this.state.searchQuery !== "") {
        this.setState({ searchQuery: "", tempSearchQuery: "" });
      }
    } else {
      // Store input separately to prevent re-renders
      if (this.state.tempSearchQuery !== value) {
        this.setState({ tempSearchQuery: value });
      }
    }
  };

 handleSearchKeyPress = (e) => {
  clearTimeout(this.typingTimeout);

  const { tempSearchQuery } = this.state;

  // Set a timeout to update search query after typing stops
  this.typingTimeout = setTimeout(() => {
    if (this.state.searchQuery !== tempSearchQuery) {
      this.setState({ searchQuery: tempSearchQuery });
    }
  }, 500); // waits 500ms after typing stops
};


 
  handleFilterChange = (category) => {
    const componentMap = {
      'Originals': WB_api_page_tabs,
      'hot-games': WB_api_page_tabs,
      'slots': WB_api_page_tabs,
      'live-casino': WB_api_page_tabs,
      'providers': WB_api_page_tabs
    };

    this.setState({ selectedFilter: category, selectedComponent: componentMap[category] || null });
  };


  getFilteredGames = () => {
    const { games, searchQuery, selectedFilter } = this.state;

    const normalizedQuery = searchQuery.toLowerCase(); // make search lowercase

    return games
      .filter((game) =>
        game.name.toLowerCase().includes(normalizedQuery)
      )
      .filter(
        (game) => selectedFilter === 'all' || game.category === selectedFilter
      );
  };

  render() {
    const { searchQuery, selectedFilter } = this.state;
    const { pathname } = this.props.location ?? {};
    const category = this.props.match?.params?.category ?? 'all';
    const filteredGames = this.getFilteredGames(); // Filter games based on category

   
    const categories = [
      { key: 'all', label: 'Lobby', icon: 'lobby.svg', path: '/casino' },
      // { key: 'Originals', label: 'Originals', icon: 'BCOriginal.svg', path: '/casino/Originals' },
      { key: 'hot-games', label: 'Hot Games', icon: 'hotGames.svg', path: '/casino/hot-games' },
      { key: 'slots', label: 'Slot Games', icon: 'slot.svg', path: '/casino/slots' },
      { key: 'live-casino', label: 'Live Casino', icon: 'liveCasino.svg', path: '/casino/live-casino' },
      { key: 'providers', label: 'Providers', icon: 'providers.svg', path: '/casino/providers' },
    ];

    const { selectedComponent: SelectedComponent } = this.state;
    return (
      <div >
        {/* header image */}


        <div className="casino-container" style={{padding:"13px"}}>
          {/* Search Bar */}
          <div className="search-container" style={{ position: 'relative' }}>
            <input
              type="text"
              value={this.state.tempSearchQuery} // Use tempSearchQuery for real-time typing
              onChange={this.handleSearchChange}
              onKeyDown={this.handleSearchKeyPress}
              placeholder="Search games"
              className="search-input"
              style={{ fontWeight: '700', paddingLeft: '40px' }} // Space for the icon
            />
            <img
              src="/assets/bcimages/Casino/svgexport-1 (1).svg"
              alt="search"
              style={{
                position: 'absolute',
                left: '10px',
                top: '65%',
                width: '25px',
                height: '25px',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            />
          </div>

          {/* Filter Buttons */}
          {/* Filter Buttons */}
          <div className="filter-buttons mt-5" >
            {categories.map(({ key, label, icon, path }) => {
              const isActive =
                (key === 'all' && (pathname === '/casino' || !categories.some((cat) => pathname.includes(cat.key)))) ||
                pathname.includes(key);
              return (
                <Link key={key} to={path}>
                  <div
                    className={`filter-button ${isActive ? 'active' : ''}`}
                    onClick={() => this.handleFilterChange(key)}
                  >
                    <img src={`/assets/bcimages/Casino/${icon}`} className="filter-btn-img" />  {/* Corrected src */}
                    {label}
                  </div>
                </Link>
              );
            })}
          </div>

          {SelectedComponent ? <SelectedComponent gameData={this.state.gameData2} category={this.state.selectedFilter} /> : ""}


          <div>
            <GamesSlotWrapper>
              {categories
                .filter((category) => category.key !== 'providers' && category.key !== 'all') // Exclude "providers" and "all"
                .map((category) => (
                  (selectedFilter === 'all') && (
                    <GamesSwiper
                      key={category.key}
                      gameData={GamesData}
                      category={category.key}
                      searchQuery2={searchQuery}
                    />
                  )
                ))}
            </GamesSlotWrapper>


            
          </div>


          {/* Filtered Games (for Originals, Hot Games, Slots, etc.) */}
          <div className="game-list">
            {selectedFilter !== 'all' && filteredGames.length > 0 && (
              <div className="game-category-item">
                {filteredGames.map((game, index) => (
                  <GridItem
                    key={index}
                    className={`grid-item ${selectedFilter === 'providers' ? 'grid-item-provider' : ''}`}
                    style={{ borderRadius: "10px", overflow: "hidden" }}
                  >
                    <Link to={`/${game.name}`}>
                      <div

                        className={`game-image ${selectedFilter === 'providers' ? 'game-image-provider' : ''}`}
                      >
                        <ResponsiveImage
                          src={game.imagePath}
                          alt={game.name}
                        />
                      </div>
                    </Link>

                    <div className="play-icon">
                      {/* Your play icon logic */}
                      <FaPlay />
                    </div>
                  </GridItem>
                ))}
              </div>
            )}
          </div>



        </div>
      </div>
    );
  }
}

export default withRouter(ExploreModal);
